import type { Game } from 'chessboard/model/game/types';

/**
 * Determine from the SAN if a move is check.
 */
export function isCheck(move: Game.Move.Model): boolean {
  if (!move || !move.san) {
    return false;
  }

  return ['+', '#'].includes(move.san.slice(-1));
}
